import React from 'react';

import {
	isPageRovoConfigProviderProps,
	isWhiteboardRovoConfigProviderProps,
	RegisteredExperience,
	type RovoConfigProviderProps,
} from '../shared-types/rovoConfigTypes.tsx';

import { RovoConfigProviderContextProvider } from './RovoConfigProviderContextProvider.tsx';
import { RovoCurrentConfigProvider } from './RovoCurrentConfigProvider.tsx';

export const RovoConfigProvider = (props: RovoConfigProviderProps): React.JSX.Element | null => {
	if (
		props.experience === RegisteredExperience.WHITEBOARD &&
		!isWhiteboardRovoConfigProviderProps(props)
	) {
		return null;
	}

	if (
		(props.experience === RegisteredExperience.VIEW_PAGE ||
			props.experience === RegisteredExperience.EDIT_PAGE) &&
		!isPageRovoConfigProviderProps(props)
	) {
		return null;
	}

	return (
		<RovoConfigProviderContextProvider value={props}>
			<RovoCurrentConfigProvider provider={props.provider} />
		</RovoConfigProviderContextProvider>
	);
};
